<template>
  <div class="app-bar-menu">
    <li v-if="isLiked">
      <button class="app-bar-button" @click="unlikeWall" v-t:title="'Unlike'">
        <base-icon name="favorite" class="highlighted-type" />
      </button>
    </li>
    <li v-else>
      <button class="app-bar-button" @click="likeWall" v-t:title="'Like'">
        <base-icon name="favorite_border" />
      </button>
    </li>
    <li v-if="isRemakeable">
      <a role="button" target="_blank" :href="remakeUrl" class="app-bar-button app-bar-icon-text-button">
        <base-icon name="remake" />
        <span class="responsive-no-phone-only" v-t>Remake</span></a
      >
    </li>
    <li>
      <a role="button" target="_blank" :href="shareUrl" class="app-bar-button app-bar-icon-text-button">
        <base-icon name="share_arrow" />
        <span class="responsive-no-phone-only" v-t>Share</span>
      </a>
    </li>
    <li>
      <a role="button" target="_blank" :href="showUrl" class="app-bar-button" v-t:title="'Open in new'">
        <base-icon name="open_in_new" />
      </a>
    </li>
  </div>
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { mapState, mapGetters, mapActions } from 'vuex'
import BaseIcon from 'vuecomponents/base_icon'
import t from 'vuedirectives/t'

export default {
  components: { BaseIcon },
  directives: { t },
  computed: {
    ...mapState(['wall', 'isLikedByCurrentUser']),
    ...mapGetters(['links', 'isRemakeable']),
    showUrl() {
      return this.links.show
    },
    remakeUrl() {
      return this.showUrl + '#remake'
    },
    shareUrl() {
      return this.showUrl + '#share'
    },
    isLiked() {
      return this.isLikedByCurrentUser
    },
  },
  methods: {
    ...mapActions(['likeWall', 'unlikeWall']),
  },
}
</script>
